module.exports = __webpack_public_path__ + "static/media/Athelas-BoldItalic.4cc4798b.woff";